// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__hF9se","consentsList":"PatientConsents_consentsList__H3qHJ","consentsListEmpty":"PatientConsents_consentsListEmpty__3wvOA"};